// Preset writes from pin verbs and undo: the cache takes each at once, the server gets them in order with one in flight per preset, so a fast undo/redo cannot land out of order.
import conform from '~/lib/conformSettings'
import api from '~/store/api'

const waiting = new Map()
const sending = new Set()

const drain = async (dispatch, id) => {
	sending.add(id)
	while (waiting.has(id)) {
		const { projectId, settings } = waiting.get(id)
		waiting.delete(id)
		await dispatch(api.endpoints.updatePreset.initiate({ projectId, id, settings }))
	}
	sending.delete(id)
}

/** Only the latest of a preset's queued writes is sent. */
export const writePreset = (dispatch, { projectId, id, settings }) => {
	dispatch(
		api.util.updateQueryData('getProject', projectId, d => {
			const preset = d?.presets?.find(p => p.id === id)
			if (preset) preset.settings = conform(settings)
		})
	)
	waiting.set(id, { projectId, settings })
	if (!sending.has(id)) drain(dispatch, id)
}
